import React from "react";
import { Box, Typography, Button, Divider } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

const EmptySkeleton = ({
  title,
  subtitle,
  onAdd,
  editMode,
  alwaysVisible = false,
  showDivider = true,
}) => {
  if (!editMode && !alwaysVisible) return null;
  const showSubtitle =
    subtitle !== undefined &&
    subtitle !== null &&
    String(subtitle).trim() !== "";

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          py: 2,
          px: 2,
        }}
      >
        <Box>
          <Typography
            onClick={editMode ? onAdd : undefined}
            sx={{
              fontWeight: 600,
              color: "primary.main",
              fontSize: "0.95rem",
              cursor: editMode ? "pointer" : "default",
              "&:hover": editMode ? { textDecoration: "underline" } : undefined,
            }}
          >
            {title}
          </Typography>

          {showSubtitle && (
            <Typography
              variant="body2"
              sx={{ color: "primary.main" }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>

        {editMode && (
          <Button
            variant="text"
            onClick={onAdd}
            sx={{
              fontSize: 22,
              minWidth: 32,
              color: "primary.main",
            }}
          >
            <EditIcon fontSize="small" sx={{ color: "#0000008a" }} />
          </Button>
        )}
      </Box>

      {showDivider && <Divider />}
    </>
  );
};

export default EmptySkeleton;